module.exports = __webpack_public_path__ + "img/ctrl-p-stub-mid-1.00914baa.svg";